const getMessagesCount = (state) => {
  return state.listCountMessagesChat
}

export default {
  getMessagesCount
}



// WEBPACK FOOTER //
// ./src/features/admin/transacoesCompraVenda/store/getters.js